<template>
    <div id="voidModal" ref="voidModal" class="modal fade" tabindex="-1" aria-labelledby="exampleModalLabel"
        aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog modal-dialog-centered laptop:!max-w-[60%] largeDesktop:!max-w-[25%]">
            <div class="modal-content">
                <div class="modal-body !p-[25px] flex flex-col gap-[20px]">
                    <div class="flex items-center justify-between">
                        <div class="flex items-center gap-[5px]">
                            <div class="w-[8px] h-[8px] rounded-full bg-[#FE5000]"></div>
                            <div class="w-[35px] h-[8px] rounded-[10px] bg-[#FE5000]"></div>
                            <h1 class="m-0 text-[20px] font-lato font-bold text-[#092E87]">Void</h1>
                        </div>
                        <button @click="hide()"
                            class="w-[34px] h-[34px] flex items-center justify-center rounded-full p-[5px] bg-[#EFEFEF] laptop:bg-[#fff] hover:laptop:bg-[#EFEFEF]">
                            <img src="../../assets/images/dismiss-orange-icon.svg" alt="Dismiss Icon"
                                class="w-[15px] h-[15px] object-contain">
                        </button>
                    </div>
                    <div class="flex flex-col gap-[20px]">
                        <div class="flex flex-col gap-[8px]">
                            <label class="!m-0 text-[16px] font-lato font-normal text-[#333]">Enter Reason</label>
                            <!-- v-if="selectedReason != null && selectedReason.reason == 'Other'" -->
                            <textarea id="addReasonsTextarea" v-model="otherReason" rows="3"
                                class="font-lato text-[14px]  rounded-[5px] p-[5px] resize-none !outline-none border-[1px] border-[#efefef] text-[#333] placeholder:text-[#999]"
                                placeholder="Enter reason here." />
                        </div>
                        <div class="flex items-center justify-center gap-[10px]">
                            <button :disabled="otherReason.length <= 0" @click="sendSharedURL()" type="button"
                                class="w-max px-4 py-1 2xl:px-8 2xl:py-2 text-[14px] 2xl:text-[16px] rounded-full 2xl:rounded-lg !border !border-[#092E87] text-[#092E87] hover:text-white hover:bg-[#092E87] disabled:cursor-not-allowed disabled:!border disabled:!border-[#CCCCCC] disabled:!text-[#CCCCCC] disabled:bg-[#fff]">
                                Send</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Modal } from "bootstrap";
import { mapActions, mapGetters } from "vuex";
import Swal from "sweetalert2";
import { useToast } from "vue-toastification";
const toast = useToast();

export default {
    props: ["invoiceDetail"],

    data() {
        return {
            modal: null,
            loading: true,
            selectedReason: null,
            otherReason: "",
            invoiceId: null,
        };
    },

    computed: {
        ...mapGetters([
            "sendVoidReason"
        ]),
    },

    watch: {
        sendVoidReason: function () {
            // if (success) {
                this.hide();
                this.$emit('success');
            // }
        }

    },

    mounted() {

    },

    methods: {
        ...mapActions([
            "sendVoidReasonData"
        ]),

        show(value) {
            this.invoiceId = value;
            if (!this.modal) {
                this.modal = new Modal(this.$refs.voidModal, {
                    backdrop: 'static',
                    keyboard: false
                });
            }
            this.otherReason = "",
                this?.modal?.show();
        },

        hide() {
            this.modal?.hide();
        },

        async sendSharedURL() {
            const payload = {
                id: this.invoiceId,
                reason: this.otherReason,
            };
            this.sendVoidReasonData(payload);
        }
    }
}
</script>